/** @jsxImportSource @emotion/react */
import React from 'react';
import { useSelector } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import { selectLoad, selectWeeks } from 'modules/schedule/store/selectors';
import Day from '../day';
import { DaysLine, DaysWrapper } from './styles';

function Days() {
  const weeks = useSelector(selectWeeks);
  const { isLoading } = useSelector(selectLoad);

  return (
    <DaysWrapper>
      {isLoading ? (
        <div className={'flex-center w-full'} style={{ height: 196 }}>
          <ClipLoader />
        </div>
      ) : (
        weeks.map((week, index) => {
          return (
            <DaysLine key={index}>
              {week.map((day) => {
                return <Day {...day} />;
              })}
            </DaysLine>
          );
        })
      )}
    </DaysWrapper>
  );
}

export default Days;
